module.exports = __webpack_public_path__ + "static/tool_holder-3c6b624df3f69b9472db3cc9b6e89804.jpg";